// Redux action types
export const SET = 'one-state-verify-service/set';
export const ADD = 'one-state-verify-service/add';
export const SETSELECTED = 'one-state-verify-service/setselected';
export const RESET = 'one-state-verify-service/reset';
